import issuedDocumentListStore from '@/modules/issued-document/store/issued-document-list-store';

export default {
    namespaced: true,

    modules: {
        list: issuedDocumentListStore,
    },
};
